{
  "version": 1,
  "asset_id": "f36df40c-975a-4600-a369-ddd9ac364a0d",
  "project_id": "81e5f51e-81a3-47ad-9e0d-7249ca4c0a70",
  "url": "/__l5e/assets-v1/f36df40c-975a-4600-a369-ddd9ac364a0d/author-sander-overmars.webp",
  "r2_key": "a/v1/81e5f51e-81a3-47ad-9e0d-7249ca4c0a70/f36df40c-975a-4600-a369-ddd9ac364a0d/author-sander-overmars.webp",
  "original_filename": "author-sander-overmars.webp",
  "size": 17382,
  "content_type": "image/webp",
  "created_at": "2026-08-30T14:15:01Z"
}
